import { lazy } from 'react';

// Layouts
import DashboardLayout from './layouts/Dashboard';
import BasicLayout from './layouts/BasicLayout';

// Guards
import AuthGuard from './components/guards/AuthGuard';

// CCA Pages
import EntitlementsContainer from './pages/Entitlements/entitlements-container';
const Packages = lazy(() => import('./pages/packages/packages'));
const PackageDetails = lazy(() => import('./pages/packages/packages-details'));
const DistributorDetails = lazy(
  () => import('./pages/packages/distributor-details'),
);
const UserDashboard = lazy(
  () => import('./pages/user-dashboard/user-dashboard'),
);
const UserInfo = lazy(() => import('./pages/user-dashboard/user-info'));
const UserGroup = lazy(() => import('./pages/user-group/user-group'));
import UserLocationContainer from './pages/user-details/UserLocationContainer';
const Reports = lazy(() => import('./pages/reports/Reports'));
// FEATURE DISABLED (Release july-2026)
// const UsageAnalysis = lazy(() =>
//   import('./pages/usage-analysis/UsageAnalysis'),
// );
// import User from './pages/user/User';
const ChangeHistory = lazy(
  () => import('./pages/change-history/ChangeHistory'),
);
const EmailDomainContractSettingsPage = lazy(
  () => import('./pages/manage-email-domains/EmailDomainContractSettingsPage'),
);

// CSA Pages
const AdminDashboard = lazy(
  () => import('./pages/csa/admin-dashboard/AdminDashboard'),
);

// Analytics Dashboard
const AuditAnalyticsDashboard = lazy(
  () => import('./pages/analytics-dashboard/AnalyticsDashboard.jsx'),
);

// CCS Pages
const OnboardContracts = lazy(() => import('./pages/ccs/onboard-contracts'));

// Individual Page
const MySubscription = lazy(
  () => import('./pages/end-user/my-susbscription/MySubscription'),
);
const EndUserManageUserIds = lazy(
  () =>
    import('./pages/end-user/end-user-manage-user-ids/end-user-manage-user-ids'),
);

// End User Registration Page
const EndUserRegistration = lazy(
  () => import('./pages/end-user/end-user-registration/end-user-registration'),
);
const EndUserRegistrationSuccess = lazy(
  () =>
    import('./pages/end-user/end-user-registration/end-user-registration-success'),
);

// Login
const Logout = lazy(() => import('./pages/auth/Logout'));
import { LoginCallback } from '@okta/okta-react';

import { SecureRoute } from './components/auth/SecureRoute';
import {
  UrlPath,
  endUserGroup,
  ccaUserGroup,
  csaUserGroup,
  viewerUserGroup,
  // FEATURE DISABLED (Release july-2026)
  // exhibitUserGroup,
  superUserGroup,
} from './constants';

// Invalid Registration Link
const InvalidRegistrationLink = lazy(
  () =>
    import('./sharedcomponents/enduser-invalid-registration-link/InvalidRegistrationLink'),
);

// FEATURE DISABLED (Release july-2026) - Home page not in release
// const Home = lazy(() => import('./pages/landing-page/home'));

// FEATURE DISABLED (Release july-2026)
// // Account Type Selection
// const AccountTypeSelection = lazy(() =>
//   import('./pages/account-type-selection/AccountTypeSelection'),
// );

const routes = [
  {
    path: '/',
    element: <SecureRoute />,
  },
  {
    path: 'login/callback',
    element: <LoginCallback />,
  },
  {
    path: UrlPath.logout,
    element: (
      <DashboardLayout>
        <Logout />
      </DashboardLayout>
    ),
  },
  {
    path: UrlPath.endUserRegistration,
    element: (
      <DashboardLayout>
        <EndUserRegistration />
      </DashboardLayout>
    ),
  },
  {
    path: UrlPath.endUserRegistrationSuccess,
    element: (
      <DashboardLayout>
        <EndUserRegistrationSuccess />
      </DashboardLayout>
    ),
  },
  {
    path: UrlPath.invalidRegistrationLink,
    element: (
      <DashboardLayout>
        <InvalidRegistrationLink />
      </DashboardLayout>
    ),
  },
  // FEATURE DISABLED (Release july-2026) - account-type-selection route
  // {
  //   path: '',
  //   element: (
  //     <AuthGuard
  //       roles={[ccaUserGroup, endUserGroup, exhibitUserGroup]}
  //       layout={DashboardLayout}
  //     />
  //   ),
  //   children: [
  //     { path: 'account-type-selection', element: <AccountTypeSelection /> },
  //   ],
  // },,
  // FEATURE DISABLED (Release july-2026) - Home page not in release
  // {
  //   path: '',
  //   element: (
  //     <AuthGuard
  //       roles={[ccaUserGroup, endUserGroup]}
  //       layout={DashboardLayout}
  //     />
  //   ),
  //   children: [{ path: 'home', element: <Home /> }],
  // },
  {
    path: '',
    element: (
      <AuthGuard
        roles={[
          superUserGroup,
          ccaUserGroup,
          csaUserGroup,
          viewerUserGroup,
          // FEATURE DISABLED (Release july-2026) - removed exhibitUserGroup
        ]}
        layout={DashboardLayout}
      />
    ),
    children: [
      { path: 'user-group', element: <UserGroup /> },
      { path: 'reports', element: <Reports /> },
      { path: 'export-users', element: <UserLocationContainer /> },
      { path: 'change-history', element: <ChangeHistory /> },
    ],
  },
  {
    path: '',
    element: <AuthGuard roles={[endUserGroup]} layout={DashboardLayout} />,
    children: [
      { path: 'my-subscription', element: <MySubscription /> },
      { path: 'manage-user-ids', element: <EndUserManageUserIds /> },
    ],
  },
  {
    path: '',
    element: (
      <AuthGuard
        roles={[
          superUserGroup,
          ccaUserGroup,
          csaUserGroup,
          viewerUserGroup,
          // FEATURE DISABLED (Release july-2026) - removed exhibitUserGroup
        ]}
        layout={DashboardLayout}
      />
    ),
    children: [
      { path: 'user-location', element: <UserLocationContainer /> },
      { path: 'entitlements', element: <EntitlementsContainer /> },
      { path: 'delete-entitlements', element: <EntitlementsContainer /> },
      { path: 'add-entitlements', element: <EntitlementsContainer /> },
      { path: 'export-entitlements', element: <EntitlementsContainer /> },
      { path: 'product-entitlements', element: <EntitlementsContainer /> },
    ],
  },
  {
    path: '',
    element: (
      <AuthGuard
        roles={[
          superUserGroup,
          ccaUserGroup,
          csaUserGroup,
          viewerUserGroup,
          endUserGroup,
        ]}
        layout={DashboardLayout}
      />
    ),
    children: [{ path: 'packages', element: <Packages /> }],
  },
  {
    path: '',
    element: (
      <AuthGuard
        roles={[superUserGroup, csaUserGroup]}
        layout={DashboardLayout}
      />
    ),
    children: [
      { path: 'analytics-dashboard', element: <AuditAnalyticsDashboard /> },
    ],
  },
  {
    path: '',
    element: (
      <AuthGuard
        roles={[superUserGroup, csaUserGroup, viewerUserGroup]}
        layout={DashboardLayout}
      />
    ),
    children: [
      { path: 'admin-dashboard', element: <AdminDashboard /> },
      {
        path: 'email-domain-contract-settings',
        element: <EmailDomainContractSettingsPage />,
      },
      // FEATURE DISABLED (Release july-2026)
      // { path: 'usage-analysis', element: <UsageAnalysis /> },
      { path: 'onboard-contracts', element: <OnboardContracts /> },
    ],
  },

  // // Using Basic Layout which excludes content & container css
  {
    path: '',
    element: (
      <AuthGuard
        roles={[
          superUserGroup,
          ccaUserGroup,
          csaUserGroup,
          viewerUserGroup,
          // FEATURE DISABLED (Release july-2026) - removed exhibitUserGroup
        ]}
        layout={BasicLayout}
      />
    ),
    children: [{ path: 'user-dashboard', element: <UserDashboard /> }],
  },
  {
    path: '',
    element: <AuthGuard roles={[endUserGroup]} layout={DashboardLayout} />,
    children: [{ path: 'user-info', element: <UserInfo /> }],
  },
  {
    path: 'packages',
    element: (
      <AuthGuard
        roles={[
          superUserGroup,
          ccaUserGroup,
          csaUserGroup,
          viewerUserGroup,
          endUserGroup,
        ]}
        layout={DashboardLayout}
      />
    ),
    children: [
      { path: 'package-details/:id', element: <PackageDetails /> },

      {
        path: 'delivery-platform-details/:id',
        element: <DistributorDetails />,
      },
    ],
  },
];

export default routes;
